import React, { SetStateAction, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CHEVRON_DOWN, CLOSE } from "../../../assets";

import ButtonV2 from "../buttonV2";
import useDropdown from "../../../utils-func/functions/usedropdown";
import { useQuery } from "react-query";
import { getLocalGovernment, getStates } from "../../../Services/services";
import { toast } from "react-hot-toast";
import { CreateCaseTypes, SearchHistoryTypes } from "../../../types";
import {
  createCase,
  editCase,
  getAdminUsers,
  getJudicialDivisionsAdmin,
} from "../../../Services/admin.service";
import {
  selectEditMode,
  setSelectedCaseDetails,
} from "../../../states/slices/globalReducer";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { Tooltip } from "@mui/material";
export const propertyNames = [
  {
    id: 1,
    name: "Certificate of Occupancy (C of O)",
  },
  {
    id: 2,
    name: "Deed of Assignment",
  },
  {
    id: 3,
    name: "Deed of Sublease / Lease Agreement",
  },
  {
    id: 4,
    name: "Survey Plan",
  },
  {
    id: 5,
    name: "Right of Occupancy",
  },
  {
    id: 6,
    name: "Allotment / Allocation Letter",
  },
  {
    id: 7,
    name: "Customary Right of Occupancy",
  },
  {
    id: 8,
    name: "Governor’s Consent",
  },
  {
    id: 9,
    name: "Receipts",
  },
  {
    id: 10,
    name: "Others",
  },
];
export interface FormFieldProps {
  title: string;
  title_number: string;
  survey_plan_number: string;
  owner_name: string;
  address: string;
  parties: string;
  subject_matter: string;
  suit_number: string;
  court_details: string;
  reliefs_sought: string;
  date_of_commencement: string;
  date_of_disposal: string;
  name_of_parties: string;
  nature_of_case: string;
  judicial_division: string;
  description_of_properties: string;
}
function CaseFormModal({
  open,
  close,
  onSuccess,
  formField,
  setFormField,
  existingCaseDetails,
  selectedRow,
  setSelectedRow,
}: {
  open: boolean;
  close: () => void;
  onSuccess: () => void;
  formField: FormFieldProps;
  setFormField: React.Dispatch<SetStateAction<FormFieldProps>>;
  existingCaseDetails?: SearchHistoryTypes | null;
  selectedRow: any;
  setSelectedRow: any;
}) {
  const [step, setStep] = useState(1);
  const { setDropdowns, closeDropDown, dropdownRef, dropdowns } = useDropdown();
  const editMode = useAppSelector(selectEditMode);
  const [erros, setErros] = useState<any>(null);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedState, setSelectedState] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedLga, setSelectedLga] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedJudiciary, setSelectedJudiciary] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [selectedUser, setSelectedUser] = useState<{
    id: number;
    name: string;
    email: string;
  } | null>(null);
  const { data: judicialDivision } = useQuery(
    ["division", 0],
    () => getJudicialDivisionsAdmin(0),
    {
      refetchOnWindowFocus: false,
      enabled: open,
    },
  );
  const [selectedProperty, setSelectedProperty] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const { data: users } = useQuery(
    ["users", "court_staff"],
    () => getAdminUsers(undefined, "court_staff"),
    {
      refetchOnWindowFocus: false,
    },
  );

  const [currentPage, setCurrentPage] = useState(1);

  const [selectedStatus, setSelectedStatus] = useState("");
  const { data: states } = useQuery("states", getStates, {
    refetchOnWindowFocus: false,
    enabled: open,
  });
  const { data: lga } = useQuery(
    ["lga", currentPage],
    () => getLocalGovernment(currentPage),
    {
      enabled: open,
    },
  );

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value, name } = e.target;

    setFormField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUploadCase = async () => {
    if (erros) {
      setErros(null);
    }
    setLoading(true);

    const payload: CreateCaseTypes = {
      title: formField.title || (selectedProperty?.name as string),
      title_number: formField.title_number,

      address: formField.address,
      survey_plan_number: formField.survey_plan_number,

      // name_of_parties: formField.name_of_parties,
      subject_matter: formField.subject_matter,
      description_of_properties: formField.description_of_properties,
      suit_number: formField.suit_number,
      court_details: formField.court_details,
      parties: formField.parties,
      date_of_commencement: formField.date_of_commencement,
      nature_of_case: formField.nature_of_case,
      date_of_disposal: formField.date_of_disposal,
      reliefs_sought: formField.reliefs_sought,

      lga_id: selectedLga?.id,
      user_id: selectedUser?.id as any,

      email: selectedUser?.email,
      state_id: selectedState?.id,
      status: selectedStatus,
    };

    try {
      const response = editMode
        ? await editCase(payload, existingCaseDetails?.id)
        : await createCase(payload);
      if (response) {
        onSuccess();
        setFormField({
          title: "",
          title_number: "",
          survey_plan_number: "",
          owner_name: "",
          address: "",
          parties: "",
          subject_matter: "",
          suit_number: "",
          court_details: "",
          date_of_commencement: "",
          date_of_disposal: "",
          name_of_parties: "",
          nature_of_case: "",
          reliefs_sought: "",
          judicial_division: "",
          // user_id: selectedUser?.id,
          description_of_properties: "",
        });
        setSelectedStatus("");
        setSelectedJudiciary(null);
        setSelectedLga(null);
        setSelectedState(null);
        setStep(1);
        close();
        dispatch(setSelectedCaseDetails(null));
      }
    } catch (error: any) {
      if (error?.response?.status === 422) {
        toast.error("Oops!, something ismissing");
        setErros(error?.response?.data?.errors);
      } else {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (existingCaseDetails) {
      setFormField({
        title: existingCaseDetails.title,
        title_number: existingCaseDetails.title_number,
        survey_plan_number: existingCaseDetails.survey_plan_number,
        owner_name: existingCaseDetails.owner_name,
        address: existingCaseDetails.address,
        parties: existingCaseDetails.parties,
        subject_matter: existingCaseDetails.subject_matter,
        suit_number: existingCaseDetails.suit_number,
        court_details: existingCaseDetails.court_details,
        date_of_commencement: existingCaseDetails.date_of_commencement,
        date_of_disposal: existingCaseDetails.date_of_disposal,
        name_of_parties: existingCaseDetails.name_of_parties,
        nature_of_case: existingCaseDetails.nature_of_case,
        reliefs_sought: existingCaseDetails?.reliefs_sought,
        judicial_division: "",
        description_of_properties:
          existingCaseDetails.description_of_properties,
      });
      setSelectedStatus(existingCaseDetails.status);
      setSelectedProperty((prev) => ({
        ...prev,
        id: 1,
        name: existingCaseDetails?.title,
      }));
    } else {
      reset();
      setSelectedProperty((prev) => ({
        ...prev,
        id: 1,
        name: "",
      }));
    }
  }, [existingCaseDetails]);

  const reset = () => {
    setFormField({
      title: "",
      title_number: "",
      survey_plan_number: "",
      owner_name: "",
      address: "",
      parties: "",
      subject_matter: "",
      suit_number: "",
      court_details: "",
      date_of_commencement: "",
      date_of_disposal: "",
      name_of_parties: "",
      nature_of_case: "",
      reliefs_sought: "",
      judicial_division: "",
      description_of_properties: "",
    });
    setSelectedStatus("");
    setSelectedRow(null);
    close();
  };

  return (
    <>
      <div
        className={`w-full h-full fixed ${
          open ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {open && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[600px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-lightGold p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                {editMode ? "Edit" : "Upload"} Case - Property Details
              </h2>
              <button
                onClick={() => {
                  reset();
                }}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>
            <div className="w-full bg-[#E9EAEB] rounded h-[2.5px] overflow-hidden mb-6">
              <div
                className="h-full bg-globalGold transition-all duration-700 ease-in-out"
                style={{
                  width: `${(step / 2) * 100}%`,
                }}
              />
            </div>
            {step === 1 && (
              <div className="flex flex-col custom-scrollbar gap-y-4 w-full p-4 h-[400px] overflow-y-scroll">
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Property Title <span className="text-red-500">*</span>
                    </span>

                    {selectedProperty?.id === propertyNames.length ? (
                      <input
                        type="text"
                        name="title"
                        value={formField.title}
                        onChange={handleInputChange}
                        autoFocus
                        className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                        placeholder="Enter Property Title"
                      />
                    ) : (
                      <>
                        <div
                          onClick={() =>
                            setDropdowns({ ...dropdowns, property: true })
                          }
                          className="flex items-center justify-between  gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                        >
                          <input
                            type="text"
                            placeholder="Select property title"
                            value={selectedProperty?.name}
                            className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                          />

                          <img
                            src={CHEVRON_DOWN}
                            className="w-[20px] h-[20px]"
                            alt=""
                          />
                        </div>
                        {propertyNames.length > 0 && dropdowns.property && (
                          <div
                            ref={dropdownRef.property}
                            className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                          >
                            {propertyNames?.map((item) => (
                              <span
                                key={item.id}
                                onClick={() => {
                                  setSelectedProperty(item);
                                  closeDropDown("property");
                                }}
                                className="px-4 py-2 text-start text-nowrap text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                              >
                                {item.name}
                              </span>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    <span className="text-xs text-red-500">
                      {erros?.title && erros?.title[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Title Number
                    </span>
                    <input
                      type="text"
                      name="title_number"
                      value={formField.title_number}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter title number"
                    />
                    {/* <span className="text-red-500 text-xs">
                      {erros?.title_number && erros?.title_number[0]}
                    </span> */}
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Location of Property
                    </span>
                    <input
                      type="text"
                      value={formField.address}
                      onChange={handleInputChange}
                      name="address"
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Location of Property"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.address && erros?.address[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Survey Plan Number
                    </span>
                    <input
                      type="text"
                      name="survey_plan_number"
                      value={formField.survey_plan_number}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Plan Number"
                    />
                    {/* <span className="text-red-500 text-xs">
                      {erros?.survey_plan_number &&
                        erros?.survey_plan_number[0]}
                    </span> */}
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Parties to the Suit (add , to differentiate)
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="parties"
                      value={formField.parties}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter parties to the suit"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.parties && erros?.parties[0]}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  {/* <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Name of Parties (add , to differentiate){" "}
                      <span className="text-red-500">*</span>{" "}
                    </span>
                    <input
                      type="text"
                      name="name_of_parties"
                      value={formField.name_of_parties}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g John Doe, Jane Doe"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.name_of_parties && erros?.name_of_parties[0]}
                    </span>
                  </div> */}
                  <div className="w-full flex flex-col gap-y-2 relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      States <span className="text-red-500">*</span>
                    </span>
                    <div
                      onClick={() =>
                        setDropdowns({ ...dropdowns, state: true })
                      }
                      className="flex items-center justify-between  gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                    >
                      <input
                        type="text"
                        placeholder="Enter state"
                        value={selectedState?.name}
                        className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                      />

                      <img
                        src={CHEVRON_DOWN}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />
                    </div>
                    {states?.length > 0 && dropdowns.state && (
                      <div
                        ref={dropdownRef.state}
                        className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                      >
                        {states?.map((item: { id: number; name: string }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedState(item);
                              closeDropDown("state");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        ))}
                      </div>
                    )}
                    <span className="text-red-500 text-xs">
                      {erros?.state_id && erros?.state_id[0]}
                    </span>
                  </div>
                </div>

                <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Local Government Area (LGA){" "}
                    <span className="text-red-500">*</span>
                  </span>
                  <div
                    onClick={() => {
                      if (!selectedState) {
                        toast.error("Select a state");
                        return;
                      }
                      setDropdowns({ ...dropdowns, lga: true });
                    }}
                    className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      value={selectedLga?.name}
                      placeholder="Select state first"
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />
                    {/* <span className="text-sm font-medium text-customDark">
                                        {selectedLga?.name || "Enter local govt area (LGA)"}
                                      </span> */}
                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {lga?.data?.length > 0 && dropdowns.lga && (
                    <div
                      ref={dropdownRef.lga}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {lga?.data?.map(
                        (item: {
                          id: number;
                          name: string;
                          state_id: number;
                          created_at: string;
                          updated_at: string;
                        }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedLga(item);
                              closeDropDown("lga");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name}
                          </span>
                        ),
                      )}
                      <div className="flex items-center gap-x-2 justify-center">
                        <Tooltip title="Previous">
                          <button
                            onClick={() =>
                              setCurrentPage(lga?.meta?.current_page - 1)
                            }
                            disabled={lga?.meta?.current_page === 1}
                            className={`w-[30px] h-[30px] rotate-180 hover:bg-gray-100 rounded-full flex items-center justify-center ${
                              lga?.meta?.current_page === 1 &&
                              "cursor-not-allowed"
                            }`}
                          >
                            <img src={CHEVRON_DOWN} alt="" />
                          </button>
                        </Tooltip>
                        <Tooltip title="Next">
                          <button
                            onClick={() =>
                              setCurrentPage(lga?.meta?.current_page + 1)
                            }
                            disabled={
                              lga?.meta?.current_page === lga?.meta?.last_page
                            }
                            className={`w-[30px] h-[30px] hover:bg-gray-100 rounded-full flex items-center justify-center ${
                              lga?.meta?.current_page ===
                                lga?.meta?.last_page && "cursor-not-allowed"
                            }`}
                          >
                            <img src={CHEVRON_DOWN} alt="" />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  )}
                  <span className="text-red-500 text-xs">
                    {erros?.lga_id && erros?.lga_id[0]}
                  </span>
                </div>
                <div className="w-full flex flex-col gap-y-2 relative">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Select court staff <span className="text-red-500">*</span>
                  </span>
                  <div
                    onClick={() => {
                      setDropdowns({ ...dropdowns, court: true });
                    }}
                    className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                  >
                    <input
                      type="text"
                      value={selectedUser?.name?.replace(/_/g, " ")}
                      placeholder="Enter court staff"
                      className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                    />
                    {/* <span className="text-sm font-medium text-customDark">
                                        {selectedLga?.name || "Enter local govt area (LGA)"}
                                      </span> */}
                    <img
                      src={CHEVRON_DOWN}
                      className="w-[20px] h-[20px]"
                      alt=""
                    />
                  </div>
                  {users?.data?.length > 0 && dropdowns.court && (
                    <div
                      ref={dropdownRef.court}
                      className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                    >
                      {users?.data?.map(
                        (item: {
                          id: number;
                          name: string;
                          email: string;
                          created_at: string;
                          updated_at: string;
                        }) => (
                          <span
                            key={item.id}
                            onClick={() => {
                              setSelectedUser(item);
                              closeDropDown("court");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item.name?.replace(/_/g, " ")}
                          </span>
                        ),
                      )}
                    </div>
                  )}
                  <span className="text-red-500 text-xs">
                    {erros?.user_id && erros?.user_id[0]}
                  </span>
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Description of Properties{" "}
                    <span className="text-red-500">*</span>
                  </span>
                  <textarea
                    rows={4}
                    onChange={handleInputChange}
                    name="description_of_properties"
                    value={formField.description_of_properties}
                    className="w-full resize-none border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter detailed description of the properties involved"
                  />
                  <span className="text-red-500 text-xs">
                    {erros?.description_of_properties &&
                      erros?.description_of_properties[0]}
                  </span>
                </div>
              </div>
            )}
            {step === 2 && (
              <div className="flex flex-col w-full gap-y-4 p-4 custom-scrollbar h-[400px] overflow-y-scroll">
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Suit Number  <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      value={formField.suit_number}
                      name="suit_number"
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. SN2023/001"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.suit_number && erros?.suit_number[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Nature of Dispute  {" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="nature_of_case"
                      value={formField.nature_of_case}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. Land Dispute, Ownership"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.nature_of_dispute && erros?.nature_of_dispute[0]}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Court <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="text"
                      name="court_details"
                      value={formField.court_details}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="e.g. High Court Lagos"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.court_details && erros?.court_details[0]}
                    </span>
                  </div>
                  <div className="w-full flex flex-col gap-y-2 relative">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Status of Dispute <span className="text-red-500">*</span>
                    </span>
                    <div
                      onClick={() => {
                        setDropdowns({ ...dropdowns, status: true });
                      }}
                      className="flex items-center justify-between gap-x-3 p-3 cursor-pointer rounded-xl border border-borderColor shadow-box"
                    >
                      <input
                        type="text"
                        value={selectedStatus}
                        placeholder="Status"
                        className="w-full bg-transparent outline-none placeholder:font-normal placeholder:text-sm placeholder:text-[#808080]"
                      />
                      {/* <span className="text-sm font-medium text-customDark">
                                        {selectedLga?.name || "Enter local govt area (LGA)"}
                                      </span> */}
                      <img
                        src={CHEVRON_DOWN}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />
                    </div>
                    {dropdowns.status && (
                      <div
                        ref={dropdownRef.status}
                        className="w-full bg-white absolute z-10 shadow-xl rounded-md mt-1 flex flex-col max-h-60 overflow-y-auto animate-dropdown"
                      >
                        {["pending", "ongoing", "concluded"].map((item) => (
                          <span
                            key={item}
                            onClick={() => {
                              setSelectedStatus(item);
                              closeDropDown("status");
                            }}
                            className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    )}
                    <span className="text-red-500 text-xs">
                      {erros?.status && erros?.status[0]}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Relief Sought
                  </span>
                  <input
                    type="text"
                    value={formField.reliefs_sought}
                    onChange={handleInputChange}
                    name="reliefs_sought"
                    className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter Reliefs Sought"
                  />
                  <span className="text-red-500 text-xs">
                    {erros?.reliefs_sought && erros?.reliefs_sought[0]}
                  </span>
                </div>
                <div className="flex items-center justify-between w-full space-x-3">
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Date of Commencement {" "}
                      <span className="text-red-500">*</span>
                    </span>
                    <input
                      type="date"
                      name="date_of_commencement"
                      value={formField.date_of_commencement}
                      onChange={handleInputChange}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter Owner Name"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.date_of_commencement &&
                        erros?.date_of_commencement[0]}
                    </span>
                  </div>
                  <div className="flex flex-col gap-y-2 w-full">
                    <span className="text-sm font-medium text-[#4F5762]">
                      Date of Disposal 
                    </span>
                    <input
                      type="date"
                      name="date_of_disposal"
                      onChange={handleInputChange}
                      value={formField.date_of_disposal}
                      className="w-full border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                      placeholder="Enter title number"
                    />
                    <span className="text-red-500 text-xs">
                      {erros?.date_of_disposal && erros?.date_of_disposal[0]}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Subject Matter  <span className="text-red-500">*</span>
                  </span>
                  <textarea
                    rows={4}
                    name="subject_matter"
                    onChange={handleInputChange}
                    value={formField.subject_matter}
                    className="w-full resize-none border border-borderColor placeholder:font-normal placeholder:text-sm placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-3"
                    placeholder="Enter the subject matter of the case"
                  />
                  <span className="text-red-500 text-xs">
                    {erros?.subject_matter && erros?.subject_matter[0]}
                  </span>
                </div>
              </div>
            )}

            <div className="flex items-end justify-end gap-x-3 p-8">
              {step === 2 && (
                <ButtonV2
                  title={"Back"}
                  btnStyle={
                    "w-fit h-fit  px-7 py-2 rounded-xl border border-borderColor"
                  }
                  textStyle={"text-sm font-medium text-customDark "}
                  handleClick={() => setStep((prev) => prev - 1)}
                />
              )}
              <ButtonV2
                title={step === 2 ? "Submit" : "Next"}
                loading={loading}
                loaderColor="#ffffff"
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                handleClick={() => {
                  if (step === 2) {
                    handleUploadCase();
                  } else {
                    setStep((prev) => prev + 1);
                  }
                }}
              />
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
}

export default CaseFormModal;
